<div class="app-wrapper">
    <gsp-app-top-bar class="flexbox"></gsp-app-top-bar>
    <gsp-announcement-banner
        *ngIf="(isEnvServiceReadyStream$ | async) && (isUserReadySream$ | async)"
    ></gsp-announcement-banner>
    <router-outlet></router-outlet>
    <map-container [id]="'map'"></map-container>
    <div class="app-loading" *ngIf="(showBusy$ | async) || isAppNavigating"></div>
</div>
